import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import * as model from "../../../models";
import { Store } from "@ngrx/store";
import { AppState } from "../../../reducers";
import { MessageActions } from "../../../actions";
import { EventApi, HttpClient } from "../../../services/webservice"

@Component({
	selector: 'event-status',
	template: `
			<event-status-presentation
				[event]="event"
				[lifecyclePhaseName]="getLifecyclePhaseName(event?.lifecyclePhase)"
				(setToSaleable)="changeLifecycle('ON_SALE')"
				(setToSuspended)="changeLifecycle('SUSPENDED')"
				(setToFinished)="changeLifecycle('FINISHED')"
				(cancelEventConfirmed)="cancelAndNotify($event)"
				
				(setToSaleableSupport)="changeLifecycleSupport('ON_SALE')">
			</event-status-presentation>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class EventStatusComponent {
	@Input() private event: model.Event
	@Output() private eventChange = new EventEmitter<model.Event>()
	private LIFECYCLE_PHASES = model.Event.LIFECYCLE_PHASES
	private lifecyclePhasesEnum = this.LIFECYCLE_PHASES

	constructor(
		private eventApi: EventApi,
		private store: Store<AppState>,
		private messageActions: MessageActions) { }

	private changeLifecycle(newLifecyclePhase: string) {
		this.eventApi.transitionLifecycle(this.event._links.transitionLifecycle.href, newLifecyclePhase).subscribe(
			event => {
				this.eventChange.emit(event)
				this.store.dispatch(this.messageActions.displayMessage("Der Veranstaltungsstatus wurde erfolgreich geändert.", "success"))
			},
			error => {
				this.handleError(error)
			}
		)
	}

	private changeLifecycleSupport(newLifecyclePhase: string) {
		this.eventApi.transitionLifecycleSupport(this.event.storageId, newLifecyclePhase).subscribe(
			event => {
				this.eventChange.emit(event)
				this.store.dispatch(this.messageActions.displayMessage("Der Veranstaltungsstatus wurde erfolgreich geändert.", "success"))
			},
			error => {
				this.handleError(error)
			}
		)
	}

	private cancelAndNotify(messageFromMerchant: string) {
		this.eventApi.cancelEvent(this.event._links.cancel.href, messageFromMerchant).subscribe(
			event => {
				this.eventChange.emit(event)
				this.store.dispatch(this.messageActions.displayMessage("Die Veranstaltung wurde abgesagt.", "success"))
			},
			error => {
				this.handleError(error)
			}
		)
	}

	private getLifecyclePhaseName(phase: string) {
		let lifecyclePhaseName
		if (phase in this.LIFECYCLE_PHASES) {
			lifecyclePhaseName = this.lifecyclePhasesEnum[phase].name
			return lifecyclePhaseName
		}
		return "Status nicht bekannt"
	}

	private handleError(error: any) {
		if (!error.messageDe) {
			error.messageDe = "Es ist ein unerwarteter Fehler aufgetreten."
		}
		this.store.dispatch(this.messageActions.displayMessage(error.messageDe, "error"));
	}
}


// WEBPACK FOOTER //
// ./src/app/components/event-components/event-status/event-status.component.ts